// src/components/auth/BugzillaPrivateRoute.js
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { configHeadersBugzilla, serverUrl } from "./../Data/Data";

const BugzillaPrivateRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const verifyToken = async () => {
      const token = localStorage.getItem("bugzillaToken");
      if (!token) {
        setIsAuthenticated(false);
        setLoading(false);
        return;
      }

      try {
        const response = await axios.get(
          `${serverUrl}/bugzilla/auth/verify`,
          configHeadersBugzilla
        );

        if (response.data.status === "Success") {
          setIsAuthenticated(true);
        } else {
          localStorage.removeItem("bugzillaToken");
          setIsAuthenticated(false);
        }
      } catch (error) {
        console.error("Token verification failed:", error);
        localStorage.removeItem("bugzillaToken");
        setIsAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    verifyToken();
  }, []);

  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center vh-100">
        <span className="ms-2">Loading...</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    return navigate("/admin/bugzilla/login");
  }

  return children;
};

export default BugzillaPrivateRoute;
